<div class="py-5 text-center text-xl/none">
  <p>Change EMPLOYEES on</p>
  <strong>{{ datahub.extDocument.Description }}</strong>
</div>

<div class="mt-12 flex w-full items-start justify-around">
  <div class="-mt-8 ml-4 flex max-w-[45%] shrink grow basis-full flex-col items-center justify-between">
    <div class="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-10">
      <button class="!h-12" mat-raised-button color="primary" (click)="back()">
        <div class="flex flex-row items-center gap-2">
          <span class="whitespace-normal text-start leading-tight">
            Back to <br />
            Timesheet
          </span>
          <mat-icon class="!h-9" svgIcon="back-to-timesheet" />
        </div>
      </button>
      <button class="!h-12" mat-raised-button (click)="clearAll()">
        Clear ALL
        <mat-icon class="!h-full !w-9 content-center !text-4xl/none">delete</mat-icon>
      </button>
    </div>
    <div class="mt-14 w-full">
      <h2 class="!m-0">Employees on the timesheet:</h2>
      <hr class="border-dashed border-b-[#ac9b9b]" />
    </div>
    @if (crew.length === 0) {
      <h2 class="w-full pt-8 text-[gray]">No employees selected yet.</h2>
    }
    <div class="crew-box flex w-full flex-col gap-2 pt-7">
      @for (emp of crew; track emp) {
        <read-only-text [shouldShowDelete]="true" [isPending]="emp.isPending" [val]="emp.display" (deleteClicked)="remove(emp)" />
      }
    </div>
  </div>

  <div
    class="flex h-3/4 max-w-[45%] shrink grow basis-full flex-col items-center justify-center rounded-3xl border border-[lightgray]"
  >
    <div class="-mt-8 flex justify-around bg-[#f0f0f0]">
      <cost-center-form-field (valueChanged)="onSearch()" />
    </div>
    <div class="mt-2 flex h-20 w-7/12">
      <mat-form-field class="w-full !text-center" [hideRequiredMarker]="true">
        <mat-label>Search Employees</mat-label>
        <input type="text" matInput [(ngModel)]="inputText" (ngModelChange)="onSearch()" />
        @if (isMoreThan3Chars) {
          <mat-hint> Minimum 3 characters required</mat-hint>
        }
      </mat-form-field>
    </div>
    <div class="crew-box flex w-full flex-col items-center justify-start gap-2 pt-1">
      @if (isSearchingEmployees) {
        <mat-spinner diameter="30" />
      }

      @if (sameCostCenter.length > 0) {
        @for (emp of sameCostCenter; track emp) {
          <button
            mat-raised-button
            class="mb-2 !block !min-h-14 w-3/4 items-center !justify-start"
            (click)="add(emp, 'sameCostCenter')"
          >
            <div class="flex flex-row items-center gap-3">
              <mat-icon class="!flex !h-full !w-9 !text-4xl/none !font-bold">arrow_backward</mat-icon>
              <div class="relative flex w-full flex-col items-baseline justify-center leading-5" notranslate>
                <span class="line-clamp-1 overflow-hidden text-wrap text-start">{{ emp.LastName }}, {{ emp.FirstName }}</span>
                <div class="flex w-full justify-between">
                  <span>{{ emp.EmpId }}</span>
                  <span class="absolute !mt-3 w-full text-end !text-xs">{{ emp.CostCenter }}</span>
                </div>
              </div>
            </div>
          </button>
        }
      }

      @if (differentCostCenter.length > 0) {
        <div class="flex w-full flex-col items-center">
          <h2 class="!m-0 py-3">Employees outside cost center {{ activeSearchCostCenter }}</h2>
          <hr class="w-3/4 border-t-2 border-black" />
        </div>
        @for (emp of differentCostCenter; track emp) {
          <button
            mat-raised-button
            class="mb-2 !block !min-h-14 w-3/4 items-center !justify-start"
            (click)="add(emp, 'differentCostCenter')"
          >
            <div class="flex flex-row items-center gap-3">
              <mat-icon class="!h-full !w-9 !text-4xl/none !font-bold">arrow_backward</mat-icon>
              <div class="flex w-full flex-col items-baseline justify-center leading-5" notranslate>
                <span class="line-clamp-1 overflow-hidden text-wrap text-start">{{ emp.LastName }}, {{ emp.FirstName }}</span>
                <div class="relative flex w-full justify-between">
                  <span>{{ emp.EmpId }}</span>
                  <span class="absolute !mt-3 w-full text-end !text-xs">{{ emp.CostCenter }}</span>
                </div>
              </div>
            </div>
          </button>
        }
      }

      @if (outsideCompanyCode.length > 0) {
        <div class="flex w-full flex-col items-center">
          <h2 class="!m-0">Unavailable Employees</h2>
          <strong>Please contact your supervisor</strong>
          <hr class="w-3/4 border-t-2 border-black" />
        </div>
        @for (emp of outsideCompanyCode; track emp) {
          <button
            mat-raised-button
            class="!z-0 mb-2 !block !min-h-14 w-3/4 items-center !justify-start bg-[#f9f9f9] !text-black"
            (click)="launchOutsideCompanyCodeModal()"
          >
            <div class="flex flex-row items-center gap-3">
              <div class="flex w-full flex-col items-baseline justify-center leading-5" notranslate>
                <span class="line-clamp-1 overflow-hidden text-wrap text-start !opacity-60"
                  >{{ emp.LastName }}, {{ emp.FirstName }}</span
                >
                <div class="relative flex w-full justify-between">
                  <span class="!opacity-60">{{ emp.EmpId }}</span>
                  <span class="absolute !z-10 !mt-3 w-full text-end !text-xs">{{ emp.CostCenter }}</span>
                </div>
              </div>
            </div>
          </button>
        }
      }
      @if (errorMessage) {
        <h2 class="w-3/4 whitespace-pre-wrap px-4">{{ errorMessage }}</h2>
      }
    </div>
  </div>
</div>
